module.exports = __webpack_public_path__ + "img/icon-basic-solid-arrowright.dba5614f.svg";